module.exports = __webpack_public_path__ + "img/reaktionen.5bcf0306.jpg";